export const SearchTypeForECReceiptList = {
	startDtAndEndDt: "startDtAndEndDt",
	receiptID: "receiptID",
} as const;

export type SearchTypeForECReceiptList = (typeof SearchTypeForECReceiptList)[keyof typeof SearchTypeForECReceiptList];
